// extracted by mini-css-extract-plugin
export var dropdown = "_ms-1";
export var hidden = "_ms-0";